module.exports = __webpack_public_path__ + "img/verification-check.747e4221.svg";